import { Component, Input } from '@angular/core';
import { ColumnMetadata } from '@valg-shared/components/table/table/column-metadata';
import { WithPropsOfType } from '@valg-shared/forms';
import { BarChartRendererComponent } from '../table/renderers/bar-chart-renderer/bar-chart-renderer.component';
import { ResultSummaryDto, ResultType } from '@shared/clients/api.generated';


export interface TopCandidates {
  name: string;
  votes: number | undefined;
  percentage: number;
}

@Component({
  selector: 'valg-dk-top-candidates',
  templateUrl: './top-candidates.component.html',
  styleUrls: [ './top-candidates.component.scss' ]
})
export class TopCandidatesComponent{
  @Input() data: TopCandidates[] = [];
  @Input() resultType!: ResultType;
  @Input() resultSummary?: ResultSummaryDto; 

  topCandidatesColumnDef: WithPropsOfType<TopCandidates, ColumnMetadata> = {
    name: {
        title: "",
        disable: true
    },
    percentage: {
        title: 'top_candidates.table.header.percentage',
        presentationComponent: BarChartRendererComponent,
        rendererOptions: new Map().set('textPath', 'name').set('numberPath', 'votes'),
    },
    votes: {
        title: "",
        disable: true
    }
  };

  hasFinalResult() {
    return this.resultType === ResultType.FinalResult;
  }

}
